<div class="console-content home-console">
  <header class="home-console__hero">
    <h1 class="home-console__title">Consola de desarrollo Epago</h1>
    <p class="home-console__subtitle">Construí, probá e integrá pagos con Epago.</p>
  </header>

  <label class="home-console__search">
    <span class="sr-only">Buscar herramientas</span>
    <input
      type="search"
      class="console-input"
      placeholder="Buscar herramientas…"
      [(ngModel)]="toolQuery"
      autocomplete="off"
    />
  </label>

  <section class="home-console__block" *ngIf="filteredQuickActions.length">
    <h2 class="home-console__heading">Acciones rápidas</h2>
    <div class="home-console__links">
      <a *ngFor="let a of filteredQuickActions" class="home-console__link" [routerLink]="a.path">{{ a.label }}</a>
    </div>
  </section>

  <section class="home-console__block" *ngIf="filteredRecent.length">
    <h2 class="home-console__heading">Usadas recientemente</h2>
    <ul class="home-console__list">
      <li *ngFor="let r of filteredRecent">
        <a [routerLink]="r.path" class="home-console__row">
          <span class="home-console__row-label">{{ r.label }}</span>
          <span class="home-console__row-path">{{ r.path }}</span>
        </a>
      </li>
    </ul>
  </section>

  <section class="home-console__block">
    <h2 class="home-console__heading">Todas las herramientas</h2>
    <div *ngFor="let g of visibleGroups" class="home-console__group">
      <h3 class="home-console__group-title">{{ g.title }}</h3>
      <ul class="home-console__list">
        <li *ngFor="let t of g.tools">
          <a [routerLink]="t.path" class="home-console__row">
            <span class="home-console__row-label">{{ t.label }}</span>
            <span class="home-console__row-path">{{ t.path }}</span>
          </a>
        </li>
      </ul>
    </div>
    <p *ngIf="!visibleGroups.length" class="home-console__empty">Ninguna herramienta coincide con la búsqueda.</p>
  </section>
</div>
